const config = {
  api: '//' + window.__hostname,
  apiV2:
    process.env.NODE_ENV === 'development'
      ? '//' + window.__hostname
      : '//' + window.__hostname,
  __index: 0,
  image: function(id?: number) {
    if (
      window.__hostname && window.__use_custom_image
    ) {
      return `//${window.__hostname}/img`;
    }

    const { configDetail } = window;
    const { use_global = '0' } = configDetail || {};
    const prefix = +use_global ? 'iglobal' : 'image';

    const index =
      typeof id != 'undefined'
        ? ((id * 1) % 6) + 1
        : (++config.__index % 6) + 1;
    return `//${prefix}${index}${window.__basename}`;
  },
  downloadImage:
    '//' + window.__hostname + window.__basename + '/api/image/download?url='
};
export default config;
